import { render, staticRenderFns } from "./addactivity.vue?vue&type=template&id=7d2e066e&scoped=true&"
import script from "./addactivity.vue?vue&type=script&lang=js&"
export * from "./addactivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2e066e",
  null
  
)

export default component.exports